const eventAggregateActionTypes = Object.freeze({
  FETCH_EVENT_AGGREGATE_REQUEST: "FETCH_EVENT_AGGREGATE_REQUEST",
  FETCH_EVENT_AGGREGATE_RESPONSE: "FETCH_EVENT_AGGREGATE_RESPONSE",
  FETCH_EVENT_AGGREGATE_ERROR: "FETCH_EVENT_AGGREGATE_ERROR",
});

export default eventAggregateActionTypes;
